import List from 'src/storage/list';

class TreatmentsModel extends List {
  id = 'treatments';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    openId: null,
    status: 'all',
    sortBy: {
      sortKey: 'date',
      desc: true
    }
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'admin/treatment/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'admin/treatment/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'admin/treatment/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      status: this.state.status === 'all' ? null : this.state.status
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }
}

const model = new TreatmentsModel();
export default model;
